module.exports = __webpack_public_path__ + "static/img/Jeral-Skelton.9a2eec8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeral-Skelton.jpg
// module id = B2Re
// module chunks = 0